import React, { useEffect, useRef, useState } from 'react'
import Modal from 'react-responsive-modal'
import { useDispatch, useSelector } from 'react-redux'
import cn from 'classnames'
import styles from './styles.module.css'
import { getSubgroupCandidates, enrollSubgroupMembers } from '../../../actions/directoryBasicEducation'
import Button from '../../../components/Button'
import { createNotification } from '../../../components/Notifications/Notifications'

export default function EnrollModal({ gid, cid, date, closeModal, enrolledMembers, parallels }) {
  const dispatch = useDispatch()
  const { subgroupCandidates } = useSelector(state => state.directoryBasicEducation)

  const [selectedMids, setSelectedMids] = useState([])
  const [saving, setSaving] = useState(false)
  const anchorRef = useRef(null)

  useEffect(() => {
    const par = parallels?.map(el => ({ year: el }))
    if (gid && date) {
      dispatch(getSubgroupCandidates(gid, { date, cid }, par))
    }
  }, [gid, date, cid, parallels, dispatch])

  const candidates = subgroupCandidates || []
  const isEnrolled = (mid) => !!enrolledMembers?.find(el => el.mid === mid)

  // мультивыбор: Shift — диапазон от якоря, Ctrl/клик — по одному
  const handleRowClick = (e, index) => {
    const candidate = candidates[index]
    if (!candidate || isEnrolled(candidate.mid)) return
    if (e.shiftKey && anchorRef.current !== null) {
      const [from, to] = [Math.min(anchorRef.current, index), Math.max(anchorRef.current, index)]
      const rangeMids = candidates
        .slice(from, to + 1)
        .filter(c => !isEnrolled(c.mid))
        .map(c => c.mid)
      setSelectedMids(prev => [...new Set([...prev, ...rangeMids])])
    } else {
      setSelectedMids(prev =>
        prev.includes(candidate.mid)
          ? prev.filter(id => id !== candidate.mid)
          : [...prev, candidate.mid]
      )
      anchorRef.current = index
    }
  }

  const handleEnroll = async () => {
    if (!selectedMids.length) {
      createNotification('error', 'Выделите хотя бы одного учащегося')
      return
    }
    setSaving(true)
    const ok = await dispatch(enrollSubgroupMembers(gid, date, selectedMids))
    setSaving(false)
    if (ok) closeModal()
  }

  return (
    <Modal
      open
      onClose={closeModal}
      center
      closeOnOverlayClick={true}
      closeOnEsc={true}
      showCloseIcon={false}
      animationDuration={1}
      classNames={{ modal: styles.pickModal }}
    >
      <h2 className={styles.modalTitle}>Выбор значения</h2>

      <div className={styles.modalBody}>
        <div className={styles.pickCard}>
          <div className={styles.pickScroll}>
            <table className={styles.pickTable}>
              <thead>
                <tr>
                  <th style={{ textAlign: 'left' }}>ФИО</th>
                  <th>Логин</th>
                </tr>
              </thead>
              <tbody>
                {candidates.length
                  ? candidates.map((c, index) => {
                    const enrolled = isEnrolled(c.mid)
                    return (
                      <tr
                        key={c.mid}
                        className={cn({
                          [styles.selectedRow]: selectedMids.includes(c.mid),
                          [styles.enrolledRow]: enrolled,
                        })}
                        onClick={(e) => handleRowClick(e, index)}
                      >
                        <td style={{ textAlign: 'left' }}>{c.fio}</td>
                        <td>{c.login}</td>
                      </tr>
                    )
                  })
                  : (
                    <tr>
                      <td colSpan={2} className={styles.emptyCell}>Нет кандидатов для зачисления</td>
                    </tr>
                  )}
              </tbody>
            </table>
          </div>
        </div>
        <div className={styles.pickInfo}>
          Выделено строк: <b>{selectedMids.length}</b>
          <span className={styles.pickHint}>Shift — выделить диапазон, Ctrl — по одному</span>
        </div>
      </div>

      <div className={styles.modalFooter}>
        <Button mode='white' onClick={handleEnroll} loading={saving} disabled={saving}>Выбрать</Button>
        <Button mode='white' onClick={closeModal}>Закрыть</Button>
      </div>
    </Modal>
  )
}
